import { formatPhoneNumber } from 'react-phone-number-input';
import DOMPurify from 'dompurify';

// Utils
import { formatAddress } from 'utils/Address';

import { TODO } from 'utils/Types';
import {
  InfoWindowContentContainer,
  InfoWindowContentHeading,
  InfoWindowContentPhoneAddress,
  InfoWindowContentStoreHours,
  InfoWindowContentStoreHoursContainer,
} from '../styles';

const InfoWindowContent = ({
  customer_name,
  phone_for_patrons,
  physical_address,
  store_hours,
}: {
  customer_name: string;
  phone_for_patrons: string;
  physical_address: TODO;
  store_hours: string;
}) => (
  <InfoWindowContentContainer className="info-window-content">
    <InfoWindowContentHeading>{customer_name}</InfoWindowContentHeading>
    {physical_address && (
      <InfoWindowContentPhoneAddress>{formatAddress(physical_address)}</InfoWindowContentPhoneAddress>
    )}
    {phone_for_patrons && (
      <InfoWindowContentPhoneAddress>{formatPhoneNumber(phone_for_patrons)}</InfoWindowContentPhoneAddress>
    )}
    {store_hours && (
      <InfoWindowContentStoreHoursContainer>
        <InfoWindowContentHeading>Store Hours</InfoWindowContentHeading>
        <InfoWindowContentStoreHours dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(store_hours) }} />
      </InfoWindowContentStoreHoursContainer>
    )}
  </InfoWindowContentContainer>
);

export default InfoWindowContent;
